import { useEffect } from "react";
import {
  installAutoClickTracking,
  installScrollDepthTracking,
  installFormFlowTracking,
} from "@/lib/gtm";

/**
 * Mount once at the app root inside <BrowserRouter>.
 * Installs delegated click tracking, scroll depth, and form lifecycle events
 * to window.dataLayer. Page views are still handled by the existing RouteTracker
 * via gtmVirtualPageView.
 */
export const AnalyticsTracker = () => {
  useEffect(() => {
    const offClick = installAutoClickTracking();
    const offScroll = installScrollDepthTracking();
    const offForm = installFormFlowTracking();
    return () => {
      offClick();
      offScroll();
      offForm();
    };
  }, []);
  return null;
};

export default AnalyticsTracker;
